module.exports = __webpack_public_path__ + "static/media/fill_61.dbea6433.svg";